import { Choices } from '../Choices';
import { ContactFromSale, DealFromSale, InvoiceFromSale, ProductFromSale } from './OrderToDeal';

export type PreviewResponseWrapper<PREVIEW extends PreviewResponse> = {
  previews: PREVIEW[];
  fakePreviews?: boolean;
};

export type PreviewResponse = InvoiceFromSale | ProductFromSale;

export type PreviewOrderResponse = DealFromSale | ContactFromSale | InvoiceFromSale;

export interface PreferenceChoicesResponse<PREVIEW extends PreviewResponse> {
  id: string;
  previewResponseWrapper: PreviewResponseWrapper<PREVIEW>;
  choices: Choices;
}

export const isDummyPreview = (preview: PreviewResponse): boolean => {
  switch (preview.type) {
    case 'invoiceFromSale':
      return !!preview.sale.order.isDummy;
    case 'productFromSale':
      return !!preview.sale.product.isDummy;
    default:
      return false;
  }
};
